<template>
  <div>
    <h1 class="display-4">{{ h1 }}</h1>
    <hr />

    <b-form>
      <b-form-group label-for="nom_ecole">
        <template slot="label">
          Ecole <span class="text-danger">*</span>
        </template>
        <b-form-input id="nom_ecole" name="name" placeholder="Nom de l'école" v-model="name" data-vv-as="Ecole" v-validate="'required'"></b-form-input>
        <div v-show="errors.has('name')" class="alert alert-danger mt-3">{{ errors.first('name') }}</div>
      </b-form-group>
      <b-form-group label-for="slider">
        <template slot="label">
          Titre du slider sur la page agenda <span class="text-danger">*</span>
        </template>
        <b-form-input id="slider" name="slider" placeholder="Titre du slider sur la page agenda" v-model="slider" data-vv-as="Titre du slider sur la page agenda" v-validate="'required'"></b-form-input>
        <div v-show="errors.has('slider')" class="alert alert-danger mt-3">{{ errors.first('slider') }}</div>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox id="images" v-model="images">
          Page agenda avec images ?
        </b-form-checkbox>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox id="carousel" v-model="carousel">
          Affichage du carousel sur la page agenda
        </b-form-checkbox>
      </b-form-group>
      <b-btn type="submit" variant="primary" @click.prevent="edit">{{ button }}</b-btn>
      <router-link to="/schools/list">
        <a class="btn btn-large btn-link">Revenir à la page précédente</a>
      </router-link>
    </b-form>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default {
  data () {
    return {
      button: '',
      carousel: true,
      h1: '',
      images: false,
      name: '',
      slider: ''
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain']),
    id () {
      return this.$route.params.id
    }
  },
  methods: {
    edit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (!this.id) {
            this.$http.post(this.domain + '/api/schools?access_token=' + this.access_token, { name: this.name, slider: this.slider, images: this.images, carousel: this.carousel }, { emulateJSON: true }).then((response) => {
              response.json().then((data) => {
                if (response.status === 200 && response.ok) {
                  this.$root.$bvToast.toast('L\'école a bien été ajoutée', {
                    title: 'Ecole ajoutée',
                    autoHideDelay: 3000,
                    append: false,
                    variant: 'success'
                  })
                  this.$router.push('/schools/list')
                }
              })
            }, (response) => {

            })
          } else {
            this.$http.post(this.domain + '/api/schools/' + this.id + '/replace?access_token=' + this.access_token, { name: this.name, slider: this.slider, images: this.images, carousel: this.carousel }, { emulateJSON: true }).then((response) => {
              response.json().then((data) => {
                if (response.status === 200 && response.ok) {
                  this.$root.$bvToast.toast('L\'école a bien été modifiée', {
                    title: 'Ecole modifiée',
                    autoHideDelay: 3000,
                    append: false,
                    variant: 'success'
                  })
                  this.$router.push('/schools/list')
                }
              })
            }, (response) => {

            })
          }
        }
      })
    }
  },
  mounted () {
    document.getElementById('nom_ecole').focus()
    if (this.id) {
      this.$http.get(this.domain + '/api/schools/' + this.id + '?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.name = data.name
          this.slider = data.slider
          this.images = data.images
          this.carousel = data.carousel
        })
      }, (response) => {

      })
      this.button = 'Editer'
      this.h1 = 'Editer une école'
    } else {
      this.button = 'Valider'
      this.h1 = 'Ajouter une école'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Schools/Edit.vue